<template>
  <v-card-actions>
    <v-btn text>
      {{ text.viewAnalysis }}
    </v-btn>

    <v-btn
      text
      @click="save"
    >
      {{ text.save }}
    </v-btn>

    <v-spacer />

    <div style="width: 50%;">
      <v-progress-linear
        color="green"
        :value="60"
        rounded
      />
    </div>
  </v-card-actions>
</template>

<script>
export default {
  props: ['save'],
  data: () => ({
    text: {
      viewAnalysis: 'View Analysis',
      save: 'Save',
    }
  })
};
</script>
